module.exports = __webpack_public_path__ + "static/media/CostaRica.af9c56be.jpg";